module.exports = __webpack_public_path__ + "static/media/corven.b3a18a38.jpg";